<template>
  <!-- 메뉴 미배정 계정 안내 화면 -->
  <div class="no-menu-container">
    <div class="no-menu-card">
      <div class="no-menu-logo">
        <img src="../../assets/img/certilogo.png" alt="logo" />
      </div>

      <div class="no-menu-icon">
        <span style="font-size: 48px; color: #bbb;">&#9656;</span>
      </div>

      <h3 class="no-menu-title">{{ $t('no_menu_title') }}</h3>
      <p class="no-menu-desc">{{ $t('no_menu_desc') }}</p>

      <a-button type="primary" block @click="onLogout">
        {{ $t('no_menu_logout') }}
      </a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoMenuAccess',

  methods: {
    onLogout() {
      this.$store.dispatch('clearLocalStorage');
      localStorage.removeItem('pwChangeRequiredManu');
      sessionStorage.removeItem('pwChangeSkippedManu');
      this.$router.push('/signin');
    },
  },
};
</script>

<style scoped>
.no-menu-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 24px;
}

.no-menu-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 48px 36px 36px;
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.no-menu-logo {
  margin-bottom: 24px;
}

.no-menu-logo img {
  height: 36px;
  object-fit: contain;
}

.no-menu-icon {
  margin-bottom: 16px;
  color: #bbb;
}

.no-menu-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.no-menu-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 28px;
}
</style>
